var ARGBRegexp = /^#(.{2})(.{2})(.{2})(.{2})$/;

/**
 * Конвертор #aarrggbb в rgba(r,g,b,a)
 * @param {Array|String} color
 * @return {Array|String}
 */
export default (function (color) {
    var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!color) {
        return '';
    }

    if (Array.isArray(color)) {
        return color.map(function (argb) {
            return ARGBToRGBA(argb, defaultColor);
        });
    }

    return ARGBToRGBA(color, defaultColor);
});

/**
 * @param {String} color
 * @return {String}
 */
var ARGBToRGBA = function ARGBToRGBA() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (color.length !== 9) {
        return color;
    }

    return color.replace(ARGBRegexp, function (source, a, r, g, b) {
        var red = parseInt(r, 16);

        if (isNaN(red)) {
            return defaultColor;
        }

        var green = parseInt(g, 16);

        if (isNaN(green)) {
            return defaultColor;
        }

        var blue = parseInt(b, 16);

        if (isNaN(blue)) {
            return defaultColor;
        }

        var alpha = Math.round(parseInt(a, 16) * 100 / 255) / 100;

        if (isNaN(alpha)) {
            return defaultColor;
        }

        return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
    });
};